import * as Lambda from '../../services/LambdaApi';
import { FeedListResponse } from '../types/FeedItem';

const listFeed = async ({
    facilityId,
    fromDate,
    toDate,
    callerResidentId,
    ResidentIds,
    StaffIds,
    GroupIds,
    Category,
    page_no = 1,
    page_size = 20,
}: {
    facilityId: string;
    fromDate: number;
    toDate: number;
    callerResidentId?: string;
    ResidentIds?: string[];
    StaffIds?: string[];
    GroupIds?: string[];
    Category?: string;
    page_no?: number;
    page_size?: number;
}): Promise<FeedListResponse> => {
    const apiPath = `/s2l/${facilityId}/listFeed`;
    const filter: {
        fromDate: number;
        toDate: number;
        facilityId: string;
        callerResidentId?: string;
        ResidentIds?: string[];
        StaffIds?: string[];
        GroupIds?: string[];
        Category?: string;
    } = {
        fromDate,
        toDate,
        facilityId,
    };
    if (callerResidentId) {
        filter.callerResidentId = callerResidentId;
    }
    if (Category) {
        filter.Category = Category;
    }
    if (ResidentIds?.length) {
        filter.ResidentIds = ResidentIds;
    }
    if (StaffIds?.length) {
        filter.StaffIds = StaffIds;
    }
    if (GroupIds?.length) {
        filter.GroupIds = GroupIds;
    }
    const params = {
        Filter: filter,
        Pagination: {
            page_no,
            page_size,
        },
        // Opt-in: the server only returns "X commented on Y's post" lines to callers that can render them.
        IncludePostComments: true,
    };
    const response = await Lambda.Post(apiPath, params, 'lambda');
    if (!response?.Result?.Content) {
        throw new Error('Error fetching feed items');
    }
    return response.Result.Content as FeedListResponse;
};

export { listFeed };
